// Permissoes.js
export const PERFIS = {
  admin:       { label: "Admin",       emoji: "⚡", color: "#FF6B2B", paginas: ["leads","kanban","negociacoes","projetos","financeiro","calendario","dashboard","vendas","clientes","usuarios","configuracoes"], podeEditar: true, veLeadsDeTodos: true, podeCriarUsuarios: true, podeExcluir: true },
  gerente:     { label: "Gerente",     emoji: "👔", color: "#8b5cf6", paginas: ["leads","kanban","negociacoes","projetos","financeiro","calendario","dashboard","vendas","clientes"], podeEditar: true, veLeadsDeTodos: true, podeCriarUsuarios: false, podeExcluir: true },
  vendedor:    { label: "Vendedor",    emoji: "👤", color: "#6366f1", paginas: ["leads","kanban","negociacoes","projetos","calendario","clientes"], podeEditar: true, veLeadsDeTodos: false, podeCriarUsuarios: false, podeExcluir: false },
  visualizador:{ label: "Visualizador",emoji: "👁️", color: "#3b82f6", paginas: ["leads","kanban","dashboard"], podeEditar: false, veLeadsDeTodos: true, podeCriarUsuarios: false, podeExcluir: false },
};

export const NAV_ITEMS = [
  { id: "leads",         label: "Leads",       emoji: "👥" },
  { id: "kanban",        label: "Kanban",       emoji: "📋" },
  { id: "negociacoes",   label: "Negociações",  emoji: "💰" },
  { id: "projetos",      label: "Projetos",     emoji: "🗂️" },
  { id: "financeiro",    label: "Financeiro",   emoji: "💳" },
  { id: "calendario",    label: "Calendário",   emoji: "📅" },
  { id: "dashboard",     label: "Dashboard",    emoji: "📊" },
  { id: "vendas",        label: "Vendas",       emoji: "🏆" },
  { id: "clientes",      label: "Clientes",     emoji: "✅" },
  { id: "usuarios",      label: "Time",         emoji: "👥" },
  { id: "configuracoes", label: "Config",       emoji: "⚙️" },
];

export function getPerfil(role) { return PERFIS[role] || PERFIS.vendedor; }
export function temAcesso(role, pagina) { return getPerfil(role).paginas.includes(pagina); }
